import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataApiService } from './data-api.service';
import { Dimension } from '@shared/models';
import { keyBy } from 'lodash-es';

@Injectable()
export class DimensionService {
  constructor(private dataApiService: DataApiService) {}

  getDimensions(datasourceId: string): Observable<{ [id: string]: Dimension }> {
    return this.dataApiService.getDimensionsNames(datasourceId).pipe(
      map(response => response.data),
      map(dimensions => keyBy(dimensions, 'id'))
    );
  }
}
